<template>
    <div>
      <img src="../../../assets/1st/Articles/Article_3/contant_5.jpg"/>
      <p class="ArticleNormal">
        城市作为人类生产生活的集聚地，不仅在文化创新和文明孕育中承担着重要角色，而且在现代化进程中发挥着物质承载和精神建构作用。信息时代，城市之间的竞争与合作更加紧密，城市发展的机遇、资源和动力不再仅仅局限于有形的物的形态，作为城市无形资产的城市形象产生的品牌价值和传播影响，对城市高质量发展尤为重要而迫切，塑造与提升城市品牌形象上升为城市发展的战略范畴。
      </p>
      <p class="ArticleNormal">
        对于每一座城市个体而言，这必然涉及到两个难点：一个是突破传统形象、走向现代城市叙事的过程很艰难；另一个则是在区域城市竞争中把握优势、建构自我形象，从而由竞争转向合作的过程很艰难。城市传播，恰好可以通过城市形象的重塑与改造，提升城市软实力帮助城市在现代化转型的过程中把握难得的战略机遇。
      </p>
      <p class="ArticleHead">
        城市轻传播时代开启
      </p>
      <p class="ArticleNormal">
        城市传播离不开媒介的力量，无论哪个时期，媒介的演变均与城市化进程相互作用，城市形象的构建与传播均依赖媒介的再现和解析。今天，在一个“万物皆媒”的时代，城市形象传播正在打破传统意义上的以新闻报道为主的媒体传播，正在经历着由传统媒体向新媒体传播的转向，以及由单维传播向多维传播的转向。
      </p>
      <p class="ArticleNormal">
        自2017年以来，在以抖音为代表的短视频创作与传播平台上，涌现出一批国内城市的身影：西安的永兴坊、摔碗酒，重庆的洪崖洞，穿楼轻轨等，原来隐藏在城市角落的特色城市文化符号成为了城市形象的新地标，市民不经意拍摄出乎意料的收获了上千万的点击量与评论数，游客的纷沓前来也将线上热度转化成为了线下旅游发展新的增长点。
      </p>
      <p class="ArticleNormal">
        在城市多维传播体系中，短视频作为一种新锐媒介却以裂变式的速度快速发展，在新老媒体交织的媒介舞台堪称“后生可畏”、大放异彩，它以传统城市媒体无可比拟的传播势能掀起一股后媒体浪潮，也标志着城市形象轻传播纪元的来临。
      </p>
      <p class="ArticleNormal">
        经过三年多的成长与沉淀，短视频在规模上和使用深度上都呈现出新态。截至2020年1月，抖音日活用户数（DAU）达到4亿，稳定的受众以及可观的规模为城市传播的质变带来了契机与可能，而城市对于短视频的利用也在深化。“抖in City美好生活节”“巨量中国”这些城市与短视频平台有目的有规划的合作，在短短数天内的视频播放总量就突破了数十亿。
      </p>
      <p class="ArticleNormal">
        可以说，随着用户的选择与消费以及城市传播规划的倚重，短视频的功能与业态也在城市传播中实现着创新与扩散，短视频成为城市空间以及城市市民的重要传播和表达工具，它陪伴在城市人左右，持续观察、书写与记录着城市。
      </p>
      <img src="../../../assets/1st/Articles/Article_3/contant_1.jpg"/>
      <p class="ArticleHead">
        短视频构建城市形象
      </p>
      <p class="ArticleNormal">
        这些鲜活而令人振奋的数据佐证着短视频城市传播的效果，“小体量”的短视频为何具有如此大的传播势能，数据背后支撑短视频运行的逻辑究竟是什么？
      </p>
      <p class="ArticleNormal">
        媒介性是短视频的底层属性。媒介即信息，它使得特定的文化符号得以选择、储存和处理。短视频是一种媒介，是生产与传播信息的物质载体，它能够精确地存储真实的城市时空信息，建构起真实的辖域。这也意味着短视频能够将城市特定的文化符号组合、连结形成具有意义的城市形象，并将此种形象传递给受众，由此建构起受众对于城市形象的初步印象。
      </p>
      <p class="ArticleNormal">
        今天，媒介技术发展使得信息传播突破时空的界限，短视频强连接、远延伸以及碎片化的媒介特征，已经将传播者“虚拟的城市日常”与受传者“遥远的在场”统一到同一时空，城市形象借助短视频媒介传播到达更广阔的空间与细微的角落，受众对城市形象的认知几率与能力都获得前所未有的提升。
      </p>
      <img src="../../../assets/1st/Articles/Article_3/contant_2.jpg"/>
      <p class="ArticleNormal">
        短视频亦是一种特殊的情感媒介。从基特勒的媒介理论来看，媒介在形塑心智、感知和社会文化方面具有重要意义。短视频的基因是影像而非图文，这一基因排列组合赋予了短视频“话语建构”的能量与张力，它强调接受者身体的感官体验，将用户引向一种“对话场景”与“情动转向”，并创造了一种丰富的生命体验。所以，当承载着城市信息的短视频扑面而来之时，“情动”力量将通过与受众身体互动，唤起并塑造其情感性的认知与喜好，驱动着受众对城市形象表象与深层文化意义的理解与接受。
      </p>
      <p class="ArticleNormal">
        正是源于内在的媒介逻辑，短视频作为城市形象的重要媒介，在一个日益媒介化的世界里实现着城市形象的连接、沟通与分享，建构着受众对城市的认知与认可。
      </p>
      <p class="ArticleHead">
        短视频传播：“被看见”的力量
      </p>
      <p class="ArticleNormal">
        法国地理学家潘什梅尔曾经说道，城市是一个景观、一处经济空间、一种人口密度；也是一种气氛、一种特征、一个灵魂。今天，短视频城市传播，正在刻画出新的中国城市形象轮廓，内容覆盖城市的生活、美食、民生、旅游、女性等各个领域，也由此汇集起规模庞大的城市既有或潜在的目标群体，以一种微视角、“远”在场、高能见度的方式，使得城市的景观被看见，城市的灵魂被触摸。
      </p>
      <img src="../../../assets/1st/Articles/Article_3/contant_3.jpg"/>
      <p class="ArticleNormal">
        城市被看见。城市形象是一个多维的概念体系，而并非一个简单的政治形象或经济形象，它聚合了自然景观、文化习俗、历史传统、市民精神等要素符号，涵盖了物质层、行为层与精神层多个面向。城市形象的书写包括对城市空间形象的再现和城市内在文化肌理的剖析。传统的城市形象呈现是从城市空间形象整体性出发，通过对城市全貌的官方化描绘勾勒城市轮廓，文化深层的挖掘与观照普遍不足甚至缺失。与传统城市形象片中的宏大叙事不同，短视频以可视化的方式“微呈现”城市文化历史肌理以及精彩趣味的城市生活，这些记录了个人美好愿望承载着城市美好形象的短视频，撕掉了城市原有的正统、刻板的印象标签，带给受众一种全新的视觉冲击和印象重塑的惊喜感。短视频在满足人类感官需求的条件下获得一种“生态位”，而城市则持久稳定地占据着人为选择的短视频“小生境”，经由短视频持续性的传播扩散，城市历久弥新、“光晕”重生。
      </p>
      <p class="ArticleNormal">
        人被看见。城市是人的生活空间与活动的集合，人是城市的缔造者与守护者，是城市形象的主体与灵魂。尽管目前的城市评价体系扭转了以GDP为目标的导向，但崇尚物质主义的观念某种程度上仍在误导媒体视角的选择。短视频文化的流行在一定意义上矫正了这一倾向，也在提醒城市与媒介回归到城市发展的初心：关注城市中活生生的人。而以UGC内容为主的短视频正好弥补了以往“城市中心主义”式形象传播所忽视的以人作为主体的城市活动，赋予了人“看见”与“被看见”的可见性空间，一个更为开阔的可供交流的新场域。在短视频营造的镜像城市，是一副充满人间烟火味道的生动图景，一个个无名姓的社会底层的“小人物”登上了地球村上的“大舞台”，演绎与创造着古老而年轻的中国正在进行着的生生不息的生活。而这些“小人物”就是平凡生活中的你、我、他，“我们”在短视频的时代被世界“看见”。
      </p>
      <p class="ArticleNormal">
        人与城市的“互见”。城市是创造意义、建构认同的空间，短视频使得人与城市“互相看见”且“可沟通”。在这个空间中，人的活动创造了城市实体空间与生活景象成为城市意义所在，同时城市正在显现其建构城市人身份认知的重要一面。
      </p>
      <p class="ArticleNormal">
        一方面，人沉浸在短视频的可见性空间，同时也构成了短视频传播城市生态链条的重要一环。在这个语境中，城市中的人不再是被动孤立的观看者，而是在传播者与受传者双重身份间转换，消解了主客体身份对立而产生的认知冲突，人得以近距离地审视城市、触摸城市、传播城市，人人都成为充满活力的城市形象的宣传大使。人与短视频的结合依托平台算法推荐这项功能的加持，已经初步形成了一个短视频城市形象传播生态圈。另一方面，城市人在利用短视频分享城市日常生活的过程当中，城市人对本土的自然、文化、历史产生更为深刻的认知与理解，进而表现出对于城市文化以及生活方式的热爱与骄傲，并传播这一独特的身份自豪感即市民精神（civicism）。这也是城市之眼，城市之魂，它对内凝聚着城市人的向心力，赋予城市人归属感、自豪感、认同感；对外，是与城市城市间身份区隔的最重要边界，是城市形象传播所依托的价值载体。今天，短视频营造的日常化高密度传播生态，正在不断强化着城市人对于城市的文化认同。
      </p>
      <p class="ArticleHead">
        亟待建立的城市短视频评估体系
      </p>
      <p class="ArticleNormal">
        随着城市化进程的推进以及媒介技术的快速迭代，媒介已经深深嵌入到城市形象传播之中。当我们在现象层面与学理层面，厘清与佐证短视频的传播逻辑以及传播价值，这并不意味着城市的短视频传播已经“功成名就”，接下来等待城市的仍是长途跋涉与深耕细作。城市应该如何借势良好的媒介基础，强化品牌传播效应？如何实现城市形象的测量与价值变现？又如何规避短视频传播过程中的可能风险？如何在更长远的层面促进城市与人的和谐发展……这一切问题都需要一个参照标准，对城市传播的影响与价值的评判指向一个科学的媒介评估体系。
      </p>
      <p class="ArticleNormal">
        城市形象建设与传播是一项复杂的系统化工程，短视频媒介评估体系是对城市传播效果的直观反应，它不仅关乎着城市传播的效果测量，同时也在城市传播的前端发挥着指导性作用。科学的评估体系帮助城市指数化、直观化、科学化地重新认识、评价城市形象，有效促进城市形象的建设策略和传播规划，对城市形象构建形成良好的引导机制。而城市短视频评估体系也并非孤立的存在体，它位于整个传播链条中的核心环节，关联与牵动着城市传播的目标、定位、主体、内容、渠道、受众等一系列传播环节，同时其他传播链条上的资源配置与振动也影响着效果评估的走向，这就需要城市对于所处的传播生态进行全面的透视与考量，方能知己知彼，致胜千里。
      </p>
      <img src="../../../assets/1st/Articles/Article_3/contant_4.jpg"/>
      <p class="ArticleNormal">
        因此，城市短视频评估体系的建立应秉承顶层观、专业观、科学观三位一体的理念，顶层观意味着政府顶层设计的重要性，缺乏系统的城市形象传播的规划会导致短视频引流的后劲不足，错失城市形象传播和品牌构建的最佳时机。专业观意味着城市整合专业的力量，系统梳理与开掘城市各类资源尤其是文化资源，提炼出城市形象核心元素与城市精神，建立以传达城市内在价值为根本目标的城市形象品牌体系，打造集文化软实力与品质感、幸福感于一体的城市品牌。科学观的基础是尊重城市传播规律，注重对媒介数据的挖掘与应用，客观准确测量出短视频是如何作用于城市传播，从直观的评估维度对比不同城市之间的效果差异，更好地讲述城市故事、书写城市历史，真正发挥短视频所带来引发变革的结构性力量。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article3"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article13.vue